import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { ModalCustomOptions } from '@app/models';

@Component({
  selector: 'mnf-modal-custom',
  templateUrl: './modal-custom.component.html',
  styleUrls: ['./modal-custom.component.scss']
})
export class ModalCustomComponent {
  /** Objeto por defecto de modal */
  config: ModalCustomOptions = {
    header: '',
    img: '',
    video: '',
    /** Título de modal */
    title: '',
    /** Información a mostrar */
    message: '',
    /** Texto de botón */
    buttonText: '',

    invertBtns: false,

    cancelText: 'Más tarde',

    footer: ''
  };

  /** Creates an instance of ModalInfoComponent */
  constructor(private modalRef: MatDialogRef<ModalCustomComponent>) { }

  /**
   * Cerra modal activo
   */
  accept() {
    this.modalRef.close(true);
  }

  cancel() {
    this.modalRef.close(false);
  }

}
